import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faLaptop, faRocket } from '@fortawesome/pro-solid-svg-icons';
import { faBuildoutLogo } from 'helpers/custom_fontawesome_icons';

import commercialEdgeLogo from 'logos/commercial_edge.png';
import riMarketplaceLogo from 'logos/ri_marketplace.png';
import spacelistLogo from 'logos/spacelist.png';
import officespaceLogo from 'logos/officespace_favicon.png';

export default function AddedBy({ lead }) {
  const { source, referralSourceLabel, user } = lead;

  let icon, tooltipText;

  if (referralSourceLabel === 'CommercialEdge') {
    tooltipText = 'CommercialEdge by Yardi';
    icon = <img className="lead-creator img-circle ml-2" src={commercialEdgeLogo} />;
  } else if (referralSourceLabel === 'RI Marketplace') {
    tooltipText = 'RI Marketplace';
    icon = <img className="lead-creator img-circle ml-2" src={riMarketplaceLogo} />;
  } else if (referralSourceLabel === 'Spacelist') {
    tooltipText = 'Spacelist';
    icon = <img className="lead-creator img-circle ml-2" src={spacelistLogo} />;
  } else if (referralSourceLabel === 'OfficeSpace') {
    tooltipText = 'OfficeSpace';
    icon = <img className="lead-creator img-circle ml-2" src={officespaceLogo} style={{ objectFit: 'contain' }} />;
  } else if (source === 'connect') {
    tooltipText = 'Connect';
    icon = <span className="fa-stack fa-lg align-middle" name="web-activity">
      <FontAwesomeIcon className="fa-stack-2x icon-purple" icon={faCircle} />
      <FontAwesomeIcon className="fa-stack-1x fa-inverse" icon={faBuildoutLogo} />
    </span>;
  } else if (source === 'web_activity') {
    tooltipText = 'Web Activity';
    icon = <span className="fa-stack fa-lg align-middle" name="web-activity">
      <FontAwesomeIcon className="fa-stack-2x text-primary" icon={faCircle} />
      <FontAwesomeIcon className="fa-stack-1x fa-inverse" icon={faLaptop} />
    </span>;
  } else {
    tooltipText = user.name;
    icon = (
      <span className="align-middle ml-2">
        <img className="lead-creator img-circle" src={user.imageUrl} />
      </span>
    );
  }

  const tooltip = <Tooltip id={`added-by-${lead.id}`}>{tooltipText}</Tooltip>;
  return <OverlayTrigger overlay={tooltip} placement="top">{icon}</OverlayTrigger>;
}

AddedBy.propTypes = {
  lead: PropTypes.shape({
    referralSourceLabel: PropTypes.string,
    source: PropTypes.string.isRequired,
    user: PropTypes.shape({
      name: PropTypes.string.isRequired,
      imageUrl: PropTypes.string.isRequired
    })
  }).isRequired
};
